import script from "./VerFoto.vue?vue&type=script&setup=true&lang=js"
export * from "./VerFoto.vue?vue&type=script&setup=true&lang=js"

import "./VerFoto.vue?vue&type=style&index=0&id=62df7994&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62df7994"]])

export default __exports__